import { ChevronDownIcon, ChevronUpIcon } from "@chakra-ui/icons";
import {
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  Text,
  Link,
} from "@chakra-ui/react";
import React, { useState } from "react";

type LinkProps = {
  to: string;
  title: string;
  isExternal?: boolean;
};
type DropdownProps = {
  title: string;
  links: LinkProps[];
  my?: number | string;
  p?: number | string;
  w?: number | string;
  mt?: number | string;
  position?:
    | "fixed"
    | "-moz-initial"
    | "inherit"
    | "initial"
    | "revert"
    | "unset"
    | "-webkit-sticky"
    | "absolute"
    | "relative"
    | "static"
    | "sticky"
    | undefined;
  top?: number | string;
  flex?: number | string;
};
const DropDownMenu = ({
  links = [],
  title = "",
  mt,
  position,
  top,
  ...props
}: DropdownProps) => {
  const [open, setOpen] = useState(false);
  return (
    <Menu isOpen={open}>
      <MenuButton
        {...props}
        as={Text}
        id="menuButton"
        fontFamily="Moriston"
        fontWeight={400}
        fontSize="16px"
        onClick={() => setOpen(!open)}
        onMouseEnter={() => setOpen(true)}
        onMouseLeave={() => setOpen(false)}
        color={{ base: "#fff", lg: "#000" }}
        _active={{
          color: "#ffb63b",
          textDecoration: "none",
        }}
        _hover={{
          color: "#ffb63b",
          textDecoration: "none",
        }}
      >
        {title} {open ? <ChevronUpIcon /> : <ChevronDownIcon />}
      </MenuButton>
      <MenuList
        bg="#ffffff"
        p={5}
        fontSize={16}
        onMouseEnter={() => setOpen(true)}
        onMouseLeave={() => setOpen(false)}
        // color="#000000"
        color={{ base: "#000", lg: "#000" }}
        mt={mt}
        position={position || "initial"}
        top={top || "initial"}
      >
        {links.map((link) => (
          <MenuItem
            id="menuItem"
            key={link.to}
            as={Link}
            href={link.to}
            isExternal={link.isExternal}
            fontFamily="Moriston"
            fontWeight={400}
            textDecoration="none"
            _hover={{
              background: "transparent",
              color: "#ffb63b",
              textDecoration: "none",
            }}
            _focus={{
              color: "#ffb63b",
              background: "transparent",
              textDecoration: "none",
            }}
            _active={{
              color: "#ffb63b",
              background: "transparent",
              textDecoration: "none",
            }}
          >
            {link.title}
          </MenuItem>
        ))}
      </MenuList>
    </Menu>
  );
};

export default DropDownMenu;
